import generate from "project-name-generator";
import { capitalizeFirstLetter } from "./common";

export function generateWords(words: number, type: "spaced" | "dashed") {
  return capitalizeFirstLetter(generate({ words })[type]);
}
